<template>
  <div>
    <h2>色のバランス</h2>
    <p class="left">
      虹の色の両端を丸くつなぐと、色の輪ができます。
      色のバランスは大切です。
      もし、同じ色ばかり持っているようでしたら、円の反対側の色を少し取り入れてみてください。
      文房具など、たとえば、カラーペン１本でもいいです。
    </p>
    <DoughnutChart
      :chartdata="data"
      :options="options"
    />
  </div>
</template>

<script>
import DoughnutChart from '../components/DoughnutChart'

export default {
  name: 'FourSeasons',
  components: {
    DoughnutChart
  },
  data() {
    return {
      data: {
        // 凡例とツールチップに表示するラベル
        labels: ['きいろ', 'オレンジ', 'あか', 'むらさき', 'あお', 'みどり'],
        // 表示するデータ
        datasets: [
          {
            data: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
            backgroundColor: ['#eec900', '#d2c100', '#a8bb00', '#58a91d', '#00a15a', '#00926e', '#00857f', '#007488', '#00709b', '#00609c', '#005ba5', '#1a54a5', '#534aa0', '#703f96', '#81378a', '#8f2e7c', '#ad2e6c', '#b91f57', '#d02f48', '#dd443b', '#e95b23', '#e67800', '#f49d00', '#f1b500'],
            borderColor: 'transparent' // 線なし
          }
        ]
      },
      options: {
        responsive: false,
        tooltips: {
          enabled: false //ツールチップを表示しない
        },
        legend: {
          // labels非表示
          display: false
        }
      }
    }
  }
}
</script>

<style scoped>
hr {
  width: 70%;
  margin-top: 50px;
}
.left {
  text-align: left;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
</style>